export default "__VITE_ASSET__fac205d2__"